export default __webpack_public_path__ + "static/media/blog.0178b106.png";